"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyContentSymbol = void 0;
exports.BodyContentSymbol = Symbol.for('BodyContentSymbol');
//# sourceMappingURL=body.js.map